import DaysmartVueComponents from '@daysmart/daysmart-vue-components'
import theme from '../theme/DSTheme'

export function install(app) {
  app.use(DaysmartVueComponents, { theme })
}
